import type { fundSheetTypeEnum } from '@/utils/enum';
import type { UseFormSetValue } from 'react-hook-form';
import type z from 'zod';
import {
  type ProjectSearchFormType,
  initialValueOfProjectSearchForm,
} from '../_models/projects-search';

/**
 * 基金シートタイプの変更時にフォームの関連フィールドをクリアする
 * @param value - 選択された基金シートタイプ
 * @param setValue - React Hook FormのsetValue関数
 * @param currentFiscalYear - 現在の会計年度
 */
export const handleFundSheetTypeChange = (
  value: z.infer<typeof fundSheetTypeEnum>,
  setValue: UseFormSetValue<ProjectSearchFormType>,
  currentFiscalYear: number,
) => {
  if (value === 'local-government') {
    setValue('period', null);
    return;
  }
  const initialValue = initialValueOfProjectSearchForm(currentFiscalYear);
  if (value === 'investment') {
    // 効果発現経路関連項目をクリア
    setValue('indicatorKeyword', initialValue.indicatorKeyword);
    setValue(
      'indicatorKeywordSearchOnlyTitleAndDescription',
      initialValue.indicatorKeywordSearchOnlyTitleAndDescription,
    );
    setValue('indicatorType', initialValue.indicatorType);
    setValue('indicatorTerm', initialValue.indicatorTerm);
    setValue('indicatorDataNatureType', initialValue.indicatorDataNatureType);
    setValue(
      'hasOnlyQualitativeIndicator',
      initialValue.hasOnlyQualitativeIndicator,
    );
    return;
  }
};
